export default "__VITE_ASSET__BpwH7E6D__"